import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';

/**
 * Hook to determine if the current theme is dark mode
 * @returns boolean indicating if the current theme is dark mode
 */
export const useIsDarkMode = (): boolean => {
	const { colorMode } = useThemeObserver();
	return colorMode === 'dark';
};
